<template>
    <div
            class="profile"
            :class="[
    {
      'profile--loading': isProfileLoading
    },
    {
      'is-info': false,
    },
  ]">
        <template v-if="!isProfileLoading">
            <div class="profile__header">
                <div class="profile__img">
                        <AvatarComponent
                                v-model="userAvatar"
                                :update-avatar-endpoint="'/companies/salesreps'"
                                :edit-mode="profileEditMode"/>
                </div>
                <div class="profile__name">
                    <div v-if="profileEditMode" class="border border-black rounded-lg">
                        <input v-model="userName" type="text"/>
                    </div>
                    <p v-else>{{ userName }}</p>
                </div>

                <div
                        v-if="isUserRole([UserRole.MANAGER, UserRole.SALES_REP])"
                        class="profile__desc">
                    <div v-if="profileEditMode" class="border border-black rounded-lg">
            <textarea
                    v-model="userDescription"
                    type="text"
                    style="min-height: 350px; padding: 15px;"
                    class="bg-transparent w-full"/>
                    </div>
                    <p v-else>
                        {{ userDescription }}
                    </p>
                </div>
                <div v-else class="profile__desc">
                    <p v-html="props.profileData?.description">
                    </p>
                </div>
                <div class="m-4">
                    <button
                            v-if="profileEditMode"
                            type="button"
                            class="btn btn-warning w-full save-profile-btn"
                            @click="save">
                        {{ $t('COMMON.SAVE_CHANGES') }}
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="grid place-items-center my-10">
                <Loader/>
            </div>
        </template>
    </div>
</template>
<script setup lang="ts">
import {ref, type Ref, defineAsyncComponent} from 'vue'
import {useManagerStore} from '~/stores/managerStore'
import {UserRole} from '~/types/userRole'
import {useUserStore} from '~/stores/userStore'
import Loader from './shared/Loader.vue'
import {isUserRole} from '~/composables/utils'
import {useAuthFetch} from '~/composables/useAuthFetch'
import {AppEvents} from '~/types/events'
import {storeToRefs} from "pinia";
import AvatarComponent from "~/components/shared/AvatarComponent.vue";
const emit = defineEmits<{
    (e: 'closed'): void
}>()



const {$event, $listen, $toast} = useNuxtApp()
const localePath = useLocalePath()

const {t: $t} = useI18n()
const {logoutUser} = useAuthStore()

const router = useRouter()

function logout() {
    logoutUser()

    router.push(localePath('/logout'))
}

const props = defineProps({
    showAs: {
        type: String || null,
        default: null,
    },
    viewFrom: {
        type: String || null,
        default: null,
    },
    readOnly: {
        type: Boolean,
        default: false,
    },
    profileData: {
        type: Object,
        default: null,
    },
    isInfo: {
        type: Boolean,
        default: false,
    },
    userProfileData: {
        type: Object,
        default: () => ({}),
    },
    isManagerEditingHisSalesProfile: {
        type: Boolean,
        default: false
    }
})

const userStore = useUserStore()
const {userInfo}: { userInfo: Ref<any> } = storeToRefs(userStore)

const store = useManagerStore()

const isProfileLoading = ref(true)


$listen('change-avatar-photo', async () => {
    await fetchManagerSellerUserProfileData()
})

interface User {
    description: string
    name: string
}

const user: Ref<User> = ref({
    description: '',
    name: '',
})
const profileData = ref({})

const userName = ref('')

const userDescription = ref('');

const profileEditMode = ref(true)

async function save() {
    let endpointRoute = 'companies/salesreps'
    let userId = userInfo.value.cognitoOwnerId

    let bodyData: any = {
        firstName: userName.value.split(' ')[0] ?? '',
        lastName: userName.value.split(' ')[1] ?? '',
        description: userDescription.value,
    }


    useAuthFetch(`/${endpointRoute}/${userId}/data`, {
        method: 'PUT',
        body: bodyData,
        onResponse() {
            $event(AppEvents.FETCH_USER_DATA)
        },
    })

    store.updateProfileInfo({data: userInfo.value})
    profileEditMode.value = false
    emit('closed')
}

async function fetchManagerSellerUserProfileData() {
    const config = useRuntimeConfig()
    const infoUrl = `/companies/salesreps/${userInfo.value.userId}`
    // eslint-disable-next-line no-case-declarations
    const {data} = await useAuthFetch(infoUrl, {
        method: 'GET',
        headers: {
            'stripe-api-key': config.public.STRIPE_API_KEY
        }
    })

    const firstName = data.value.salesRepData.firstName;
    const lastName = data.value.salesRepData.lastName;
    const description = data.value.salesRepData.description;

    userName.value = `${firstName} ${lastName}`;
    userDescription.value = `${description}`;
    userAvatar.value = `${data.value.salesRepData.image}`;

}

onMounted(async () => {
    if (props.isManagerEditingHisSalesProfile) {
        setTimeout(async () => await fetchManagerSellerUserProfileData(), 0);
        isProfileLoading.value = false
        return;
    }
})

onUpdated(() => {
    if (props.profileData) {
        isProfileLoading.value = false
    }
})

const userAvatar = ref('');
</script>
<style lang="scss" scoped>
@use '@/assets/scss/abstracts/mixins';

/*MENU RIGHT SITE*/
.preview-elements {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 56%;
  background: #fff;
  border-radius: 20px;
  border: 1px solid #e5e5e5;
  opacity: 0.4;
}

.preview-elements p {
  color: #000;
  font-weight: 900;
}

/*-----------------*/
.profile_manager_section {
  background: #fff;
  min-height: 160vh;
  display: block;
  margin: 25px 0;
}

.content-profile-manager {
  display: flex;
  margin: 0px 50px 10px 50px;
  gap: 20px;
}

.meet-me__button {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  padding: 30px 80px !important;
  color: var(--text-color, #fff) !important;
  background-color: var(--bg-color) !important;

  &--init {
    --bg-color: #353535;
  }

  &--added {
    --bg-color: #3870ff;
  }
}

.profile {
  height: max-content;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.7);
  border: solid 1px #e1e1e1;
  --btn-text-color: #fff;
  --btn-bg-color: #ffa800;

  &--blue {
    --btn-text-color: #fff;
    --btn-bg-color: #3870ff;
    background: url('@/assets/img/profile/profile_salesman_background.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  &--loading {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      z-index: 100;
      background: rgb(255, 255, 255);
      background: linear-gradient(
                      130deg,
                      #ffa800 0%,
                      #ffffff 50%,
                      #3870ff 100%
      );
      background-size: 200% 200%;
      animation: loadingGradient 1s ease infinite;
    }
  }

  &.is-info {
    background: #f6f6f6;
    height: auto;
  }

  &__line {
    display: flex;
    align-items: center;
    gap: 15px;
    padding-top: 20px;
  }

  &__img {
    display: flex;
    justify-content: center;
    padding: 15px 0px;
    position: relative;

    img {
      @include mixins.maskAvatar(212px);
    }

    &-edit-btn {
      /**
      TRZEBA ZROBIĆ WSPOLNĄ KLASĘ, ALBO KOMPONENT
       */
      --bg-color: #fff;
      --fill-color: var(--bg-color);
      --padding: 50px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      background-color: var(--bg-color);
      padding: 50px;
      padding: var(--padding);
      border-radius: 50%;
      cursor: pointer;
      transition: background-color 0.15s ease;

      &:hover {
        --bg-color: #e1e0e0;
      }
    }
  }

  .save-profile-btn {
    --bg-color: var(--btn-bg-color);
    --text-color: var(--btn-text-color);
    --stroke-color: var(--btn-text-color);
  }

  &__name {
    display: flex;
    justify-content: center;
    padding: 5px;

    p,
    input {
      color: #353535;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 25px;
      text-align: center;
      background: transparent;
    }
  }

  &__company {
    display: flex;
    justify-content: center;
    padding: 5px;
    border-radius: 20px;

    p {
      color: rgba(53, 53, 53, 0.5);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 25px;
    }
  }

  &__opinion {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 20px;
    gap: 8px;

    &-rate {
      color: #353535;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 25px;
    }

    &-summary {
      color: rgba(53, 53, 53, 0.5);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 25px;
    }
  }

  &__desc {
    margin: 0 45px;
    padding: 20px 0px;

    p {
      color: #353535;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 25px;
    }
  }

  &__navigation {
    margin: 70px 10px 25px 10px;

    &-list {
      display: flex;
      flex-direction: column;
      gap: 15px;

      &-item {
        display: flex;
        padding: 15px 0;
        border-radius: 20px;
        background: #f6f6f6;
        justify-content: center;
        align-content: center;
        align-items: center;
        gap: 13px;
        color: #353535;

        &.router-link-active {
          background: #353535;
          border-radius: 20px;
          color: #fff;

          svg {
            --fill-color: #fff;
          }
        }

        &:hover {
          background: #353535;
          border-radius: 20px;
          color: #fff;

          svg {
            --fill-color: #fff;
          }
        }

        p {
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
        }

        &--active {
          background: #353535;
          border-radius: 20px;
          border: 1px solid #333;
          color: #fff;
        }
      }
    }
  }

  &__social {
    display: flex;
    padding: 14px 30px;
    border-radius: 20px;
    background: #f6f6f6;
    margin: 0px 15px;
    justify-content: space-around;

    &-icon {
      width: 36px;
      height: 36px;
      @media screen and (max-width: 1280px) {
        width: 28px;
        height: 28px;
      }
    }

    /* ROLES */
    &--sales-rep {
      background: transparent;
    }
  }

  &__footer {
    //margin: 35px 15px 15px 40px;
  }

  &__link {
    display: flex;
    padding: 8px 0;
    align-items: center;
    gap: 11px;
    //justify-content: space-between;
    p,
    input {
      color: #353535;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 30px;
      width: 100%;
    }
  }

  .button-arrow,
  .button-delete {
    display: flex;
    padding: 13px 38px;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    background: #3870ff;
  }

  .button-delete {
    padding: 13px 20px;
    background: #353535;

    img {
      min-width: 25px;
    }
  }
}

.product-slider {
  margin: 15px;
}

.product-person p {
  color: #353535;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  text-transform: uppercase;
}

.product-company p {
  color: rgba(53, 53, 53, 0.5);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  text-transform: uppercase;
}

.product-add-time p {
  color: rgba(53, 53, 53, 0.5);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  text-transform: uppercase;
  text-align: right;
}

.product-desc {
  text-align: left;
  margin: 30px 0;
}

.product-desc p {
  color: #353535;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
}

.edit {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
  cursor: pointer;

  &__button {
    --bg-color: #e6e6e6;
    background-color: var(--bg-color);
    transition: all 0.2s ease;
    display: inline-block;
    border-radius: 50%;

    svg {
      --fill-color: var(--bg-color);
    }

    &--active {
      --bg-color: var(--btn-bg-color);
      --text-color: var(--btn-text-color);
      --stroke-color: var(--btn-text-color);
    }
  }
}

/* FAQ */
.faq {
  border-radius: 20px;
  background: #353535;
  padding: 35px;
  height: auto;
  margin: 15px;
}

.accordion-item:first-of-type .accordion-button {
  border-radius: 20px;
}

.accordion-item {
  border-radius: 20px;
  background: #f6f6f6;
  margin-top: 15px;
}

.accordion-item:first-of-type {
  border-radius: 20px;
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-radius: 20px;
}

.accordion-item:last-of-type {
  border-radius: 20px;
}

.accordion-button {
  border-radius: 20px;
}

.accordion-button:not(.collapsed) {
  color: #ffffff;
  background-color: #353535;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}

.accordion-body {
  background: #ffffff;
  border-radius: 20px;
}

.accordion-button:focus {
  box-shadow: none;
}

@media (max-width: 1496px) {
  .profile {
    &__line {
      font-size: var(--font-xsmall);
    }

    &__name p {
      font-size: var(--font-small);
    }

    &__company p {
      font-size: var(--font-xsmall);
    }

    &__opinion {
      padding-top: 10px;

      p {
        font-size: var(--font-xsmall);
      }
    }

    &__desc {
      padding-top: 10px;
      margin: 0 15px;

      p {
        font-size: var(--font-exsmall);
      }
    }

    &__navigation {
      margin: 20px 10px;

      &-list {
        &-item {
          padding: 10px 0;
          gap: 10px;

          p {
            font-size: var(--font-xsmall);
          }
        }

        svg {
          width: 22px;
        }
      }
    }

    &__link {
      padding: 0;
      font-size: var(--font-xsmall);
    }
  }
  .edit {
    &__button {
      svg {
        width: 35px;
        height: 35px;
      }
    }
  }
}

/* 1440px
@media screen and (max-width: 1440px) {
.content-profile-manager {
  margin: 30px 10px 30px 10px;
}
.left-profile-manager {
  //width: 27%;
}
.profile-header-desc {
  margin: 0 25px;
}
.backlink {
  width: 405px;
  padding: 35px 56px;
}
.product-slider {
  margin-bottom: 0px;
}
.product-info-left {
  gap: 0px;
}
.menu-item {
  width: 95px;
  height: 100px;
}
.menu-item p {
  font-size: 12px;
}
.profile-footer {
  margin: 15px;
}
.profile-links p {
  font-size: 14px;
}
.button-arrow {
  padding: 7px 28px;
}
.menu-item-manager-section p {
  font-size: 16px;
}
.menu-item-manager-section {
  padding: 12px 0;
}
.menu-item-manager p {
  font-size: 16px;
}
.menu-item-manager {
  padding: 12px 0;
}
}
*/
/*1280px
@media screen and (max-width: 1280px) {
a.social-icon {
  width: 28px;
  height: 28px;
}
a.button-meet {
  font-size: 14px;
}
.button-meet {
  padding: 12px 0px;
}
a.button-link {
  font-size: 16px;
}
.button-link {
  padding: 8px 0px;
}
.product-person p {
  font-size: 12px;
}
.product-company p {
  font-size: 12px;
}
.product-add-time p {
  font-size: 12px;
}
.product-desc p {
  font-size: 16px;
}
input#submit_price {
  width: 62px;
  height: 35px;
}
form#price {
  gap: 15px;
  height: 35px;
}
.meet-content-left {
  width: 50%;
}
.meet-content-right {
  width: 56%;
}
.meet-content-desc {
  gap: 0;
}
.meet-content-desc-first p {
  font-size: 16px;
}
.meet-content-desc-second p {
  font-size: 16px;
}
.product-info {
  margin: 0;
}
.product-desc {
  margin: 5px 0;
}
.opinion-content-slim-top {
  gap: 15px;
}
.opinion-desc-top p {
  font-size: 14px;
}
.opinion-desc-user p {
  font-size: 16px;
}
.opinion-content-slim {
  padding: 25px 15px;
}
.star-ratings p {
  font-size: 14px;
}
.opinion-add-time p {
}
}
*/

@media screen and (max-width: 768px) {
  .profile__navigation-list-item {
    padding: 8px 0;
    margin-bottom: 5px;
    box-shadow: 0 5px 5px rgb(0 0 0 / 22%);
  }
  .profile__social {
    padding: 0;
    margin: 0;
    background: #fff;
  }
  .profile--blue {
    background-size: cover;
    background-repeat: no-repeat;
  }
  .profile {
    background: #ffffff;

    &__header {
      /*display: grid;
      grid-template-columns: 0.5fr 1fr;
      grid-template-rows: 0.5fr 0.1fr 0.1fr 0.5fr;
      gap: 10px 10px;
      grid-template-areas:
        'line line'
        'img name'
        'img phone'
        'img mail'
        'desc desc';*/
      display: flex;
      flex-direction: column;
      text-align: center;
    }

    &__company {
    }

    &__opinion {
    }

    &__line {
      grid-area: line;
    }

    &__img {
      grid-area: img;
    }

    &__name {
      grid-area: name;
      align-items: flex-end;

      p {
      }
    }

    &__desc {
      grid-area: desc;
      text-align: center;
    }

    &__header--phone {
      margin: 0 20px;
      border: 2px solid #353535;
      gap: 10px;
      font-size: 14px;
      padding: 5px;
      background: #fff;
    }

    &__separate {
      border-top: 1px solid #353535;
    }
  }
  .edit__button svg {
    width: 33px;
    height: 33px;
  }
}

@media screen and (max-width: 576px) {
  .meet-content-slim {
    height: 618px;
  }
}
</style>
